import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "single-date-picker" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_calendar = _resolveComponent("calendar")!
  const _component_datePicker = _resolveComponent("datePicker")!
  const _component_cancel = _resolveComponent("cancel")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "single-date-picker__icon-container single-date-picker__icon-container--calendar",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openCalendar()))
    }, [
      _createVNode(_component_calendar)
    ]),
    _createVNode(_component_datePicker, {
      id: "date-picker",
      "wrapper-class": "single-date-picker__date-wrapper",
      "input-class": "single-date-picker__input",
      "calendar-class": "single-date-picker__calendar",
      format: _ctx.dateFormatter,
      enabledDates: _ctx.enabledDates,
      disabledDates: _ctx.disabledDates,
      value: _ctx.value,
      placeholder: _ctx.placeholder,
      onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('input', $event)))
    }, null, 8, ["format", "enabledDates", "disabledDates", "value", "placeholder"]),
    (!!_ctx.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "single-date-picker__icon-container single-date-picker__icon-container--cancel",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.clearDate && _ctx.clearDate(...args)))
        }, [
          _createVNode(_component_cancel)
        ]))
      : _createCommentVNode("", true)
  ]))
}